import{StrictMode}from"react";
import{createRoot}from"react-dom/client";
import{AppI18nProvider}from"./lib/appI18n";
import App from"./App";
import"./styles/foundation.css";
import"./styles/identity-access.css";
import"./styles/app.css";
import"./styles/ui002.css";
import"./styles/ui003.css";
import"./styles/ui004.css";
import"./styles/ui005.css";
import"./styles/agent-control.css";
import"./styles/knsaix-os.css";
import"./styles/tokens.css";
import"./styles/person-detail.css";
const root=document.getElementById("root");
if(!root)throw new Error("KNSAIX web root is missing.");
createRoot(root).render(<StrictMode><AppI18nProvider><App/></AppI18nProvider></StrictMode>);
